<!--
Author: TangChen
Date: 2018-10-31
Desc: 风险评测组件，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="risk">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/risk' }">风险测评</el-breadcrumb-item>
                <el-breadcrumb-item>风险测评试题</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-risk-header">
            <div class="risk-header-title">风险测评</div>
            <div class="risk-header-text">
                根据《证券期货投资者适当性管理办法》投资前请填写风险测评问卷
            </div>
        </div>
        <risk-ques :data="data" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import riskQues from "@/components/acctInfo/riskQuesDc.vue";
export default {
    name: "RiskTest",
    components: {
        riskQues
    },
    mixins: [mixin],
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    risk: true,
                    url: "risk"
                };
            }
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-risk-header {
    display: flex;
    padding: 17px 0 21px;
    margin: auto;
    width: 1160px;
    border-bottom: 1px solid var(--color-border-base);
    .risk-header-title {
        font-family: Source Han Sans CN;
        font-size: 20px;
        font-weight: 500;
        color: var(--color-text-primary);
    }
    .risk-header-text {
        font-family: Roboto;
        font-size: 16px;
        font-weight: normal;
        color: var(--color-text-accent);
        margin-top: 5px;
        margin-left: 8px;
    }
}
</style>
